<template lang="pug">
    .conference
        input(type="checkbox" :id="labelId" name="activities" @change="pickedActivity")
        label(:for="labelId")
            .conference-row
                h4.event-title {{ activity.package_name }}
                p.cost {{ currency }} {{ fee }}

            .conference-row
                p {{ activity.brief_description }}

            .conference-row
                a(href="" @click.prevent="clickedActivity") More details
</template>

<script>
    import _ from 'lodash';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'Activity',
        data() {
            return {
                labelId: null,
                currency: 'USD',
                fee: 0
            }
        },
        computed: mapGetters(['getCurrency', 'currencyDetails']),
        props: ['activity'],
        methods: {
            ...mapActions(['getRates']),
            showPopup() {
                this.$refs.activityPopup.toggle()
            },
            clickedActivity() {
                this.$emit('clickedActivity', { 'id': this.activity.id });                
            },            
            pickedActivity(event) {
                if(event.target.checked) {
                    this.$emit('pickedActivity', [{ 
                        checked: true, 
                        'activity_package_id': this.activity.id,
                        'activity_cost': this.activity.price
                    }])
                } else {
                    this.$emit('pickedActivity', [{ checked: false, 'activity_package_id': this.activity.id }])
                }
            },
            updateFee() {
                this.currency = 'USD';
                this.fee = this.activity.price;
            },
            onCurrencyUpdate() {
                if(this.getCurrency == 'LKR') {
                    this.getRates().then(() => {

                        this.currency = this.getCurrency;

                        this.fee = this.activity.price * this.currencyDetails.lkr;
                    });
                } else {
                   this.updateFee() 
                }
            },            
        },
        mounted() {
            this.labelId = _.uniqueId(),
            this.onCurrencyUpdate();
        },
        watch: {
            getCurrency: {
                handler: function() {
                    this.onCurrencyUpdate();
                }
            }
        }        
    }
</script>

<style lang="sass" scoped>
    @import "@/assets/css/2-base/_variables.sass"
    @import "@/assets/css/2-base/_placeholder.sass"
    @import "@/assets/css/3-components/_conference.sass"
</style>


